<section [tabindex]="tabindex" [attr.aria-labelledby]="description" [ngClass]="[carouselClass]" (focusin)="allFocusIn($event)">
    <div [id]="description" class="accessibility-hidden">{{ name }}</div>
    <div class="play-pause-buttons" *ngIf="playIcon && pauseIcon">
        <button class="toggle-button" (click)="toggleAutoplayOnBtnClick()">
            <xm-media-image *ngIf="autoPlayStopped" [imageOptions]="playIcon"></xm-media-image>
            <xm-media-image *ngIf="!autoPlayStopped" [imageOptions]="pauseIcon"></xm-media-image>
        </button>
    </div>
    <div class="carousel-holder" [ngClass]="{ 'outside-arrows': outsideArrows, 'visible-arrows': showUpperArrows }"
        (mouseenter)="holderMouseEnter()" (mouseleave)="holderMouseLeave()">
        <button [attr.aria-label]="allyLeftArrowText" *ngIf="upperSettings.navigation" [ngClass]="[upperPrevBtnClass]" class="swiper-button-prev prev-upper-button upper-button">
            <xm-media-image [imageOptions]="leftArrowIcon"></xm-media-image>
        </button>
        <div id="{{ upperSettings.id }}" class="upper-carousel carousel" (focusout)="upperCarouselFocusOut()">
            <div class="swiper-wrapper">
                <ng-content select="[upper]">
                </ng-content>
            </div>
        </div>
        <button [attr.aria-label]="allyRightArrowText" *ngIf="upperSettings.navigation" [ngClass]="[upperNextBtnClass]" class="swiper-button-next next-upper-button upper-button">
            <xm-media-image [imageOptions]="rightArrowIcon"></xm-media-image>
        </button>
    </div>
    <div class="pagination-container">
        <div [ngClass]="paginationClassName" (mouseenter)="paginationMouseEnter()" (mouseleave)="paginationMouseLeave()"></div>
    </div>
    <div class="carousel-holder" *ngIf="lowerSettings" [ngClass]="{ 'outside-arrows': lowerSettings.outsideArrows }">
        <div *ngIf="showLowerArrows" class="swiper-button-prev prev-lower-button"></div>
        <div id="{{ lowerSettings.id }}" class="lower-carousel carousel">
            <div class="swiper-wrapper">
                <ng-content select="[lower]">
                </ng-content>
            </div>
        </div>
        <div *ngIf="showLowerArrows" class="swiper-button-next next-lower-button"></div>
    </div>
</section>
